import React, { useState, useEffect } from "react";
import { Heading } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import ContentCard from "../../Common/Layout/ContentCard";
import { UsersContextProvider } from "../../Context/UsersContext";
import { ProductsContextProvider } from "../../Context/ProductsContext";
import UserForm from "./UserForm";
import useFetch from "../../../hooks/useFetch";
import Body from "../../Common/Body";

const User = () => {
  const { id } = useParams();
  const [user, setUser] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const parsed = new URLSearchParams(window.location.search);
  const { get } = useFetch();

  const setUserData = async () => {
    if (isNaN(id)) {
      setUser({ roleId: parsed.get("roleId") });
    } else {
      setUser(await get(`/users/${id}`));
    }
    setIsLoading(false);
  };

  useEffect(() => {
    setUserData();
  }, [useParams().id]);

  return (
    <ProductsContextProvider>
      <Body
        title={`${isNaN(id) ? "Nuevo usuario" : "Edición de usuario id " + id}`}
        isLoading={isLoading}
      >
        <ContentCard>
          <Heading variant="h2">Datos del usuario</Heading>
          <UserForm user={user}></UserForm>
        </ContentCard>
      </Body>
    </ProductsContextProvider>
  );
};

export default User;
